import React from 'react';
import { cn } from '@/lib/utils';

interface TooltipProps {
    children: React.ReactNode;
    content: string;
    show: boolean;
    position?: 'right' | 'left' | 'top' | 'bottom';
    className?: string;
}

const Tooltip: React.FC<TooltipProps> = ({ children, content, show, position = 'right', className }) => {
    const positionClasses = {
        right: 'left-full ml-2 top-1/2 -translate-y-1/2',
        left: 'right-full mr-2 top-1/2 -translate-y-1/2',
        top: 'bottom-full mb-2 left-1/2 -translate-x-1/2',
        bottom: 'top-full mt-2 left-1/2 -translate-x-1/2'
    };

    const arrowClasses = {
        right: 'absolute right-full top-1/2 -translate-y-1/2 border-4 border-transparent border-r-background-light-elevated dark:border-r-background-dark-elevated',
        left: 'absolute left-full top-1/2 -translate-y-1/2 border-4 border-transparent border-l-background-light-elevated dark:border-l-background-dark-elevated',
        top: 'absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-background-light-elevated dark:border-t-background-dark-elevated',
        bottom: 'absolute bottom-full left-1/2 -translate-x-1/2 border-4 border-transparent border-b-background-light-elevated dark:border-b-background-dark-elevated'
    };

    return (
        <div className="relative">
            {children}
            {show && (
                <div className={cn(
                    "absolute px-2 py-1 bg-background-light-elevated dark:bg-background-dark-elevated text-text-primary-light dark:text-text-primary-dark text-xs rounded-md whitespace-nowrap z-[9999] border border-border-light dark:border-border-dark-subtle shadow-lg",
                    positionClasses[position],
                    className
                )}>
                    {content}
                    <div className={arrowClasses[position]}></div>
                </div>
            )}
        </div>
    );
};
export default Tooltip;